import { useTranslation } from 'next-i18next'

import { FC, useContext } from 'react'

import { useState } from 'react'
import QuickOrderTabs from './quick-order-tabs'
import CreateListOrder from './create-list-order'
import { useSavedlistsQuery } from '@framework/savelist/get-all-lists'
import { IUser } from '@contexts/user/user.utils'
import { UserContext } from '@contexts/user/user.context'
import CreateQuickOrder from './create-quick-order'
import CreateImportOrder from './create-import-order'

const QuickOrderPage: FC = () => {
  const { t: translate } = useTranslation('quickorder')
  const [activeTab, setActiveTab] = useState(0)
  const { user } = useContext(UserContext) as IUser
  const { data, isLoading } = useSavedlistsQuery(user?.id, true)

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <CreateListOrder
            savedLists={data?.data}
            isSavedListsLoading={isLoading}
          />
        )
      case 1:
        return <CreateQuickOrder />
      case 2:
        return <CreateImportOrder />
      default:
        return null
    }
  }

  return (
    <div className="p-6 bg-white shadow rounded">
      <h4 className="text-xl font-semibold text-brand sm:text-2xl mb-3 ">
        {translate('text-create-an-order')}
      </h4>
      <p className="pb-2 mb-4 border-b text-brand-dark">
        {translate('text-create-an-order-description')}
      </p>

      <QuickOrderTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="bg-gray-100 py-5">{renderContent()}</div>
    </div>
  )
}

export default QuickOrderPage
